import React, { Component } from 'react';
import { connect } from 'react-redux';
import { routes } from '../../../../../utility/constants/constants';
import * as actions from '../../../../../redux/actions/index';
import { decode, encode } from 'base64-arraybuffer';
import { extractExtention, getUser} from '../../../../../utility/utility';
import LogBookFeedback from '../../../../component/Accounts/LogBook Area/LogBook Feedback/LogBookFeedback';

class LogBookFeedbackContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            base64: [],
        }
    }

    onSignatureAdded = (values) => {
        let image = values.sigImageFile;
        let form = values.logFeedbackValues
        this.setState({
            base64: [image]
        }, ()=>{
            if (this.state.base64.length > 0) {
                const arrayBuffer = [];
                this.state.base64.map((url, i) => {
                    if (!url.photo_urls) {
                        let base_photo = null;
                        const image = url.split(',');
                        base_photo = image[1];
                        arrayBuffer.push(decode(base_photo))
                    }
                })
                if (form.logbook_log.comment.length == 0) {
                    delete form.logbook_log.comment
                }
                const extentions = extractExtention(['img.jpg']);
                let logId = this.props.history.location.pathname.split('/')[this.props.history.location.pathname.split('/').length-1]
                this.props.getLogbookPresignedUrl(logId, extentions, arrayBuffer, this.props.createLogbookLog, form)
                this.props.history.push(routes.LOGBOOK_THANKYOU);
                               
            }
        })
    }

    scanLogbookPage = () => {
        this.props.history.push(routes.SCAN_LOGBOOK_QR)
    }
    
    render() {        
        return (
            <div>
                <LogBookFeedback 
                onSignatureAdded={this.onSignatureAdded} 
                scanLogbookPage={this.scanLogbookPage}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getLogbookPresignedUrl: (logId, extentions, arrayBuffer, createLogbookLog, form) => dispatch(actions.getLogbookPresignedUrl(logId, extentions, arrayBuffer, createLogbookLog, form )),
        createLogbookLog: (id, form) => dispatch(actions.createLogbookLog(id, form)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogBookFeedbackContainer);